import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { API_PATH_PREFIX } from "@dentally/auth/auth-constants";
import { StatusCodes } from "http-status-codes";
import { catchError, Observable, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BaseAuthHttpService {
  constructor(private _http: HttpClient) {}

  public getAccessToken(): Observable<{ accessToken: string }> {
    return this._post<{ accessToken: string }>();
  }

  protected _delete(): Observable<void> {
    return this._http.delete<void>(API_PATH_PREFIX, { withCredentials: true });
  }

  protected _post<T>(pathSuffix = "", body: any = null, options: Record<string, any> = {}): Observable<T> {
    return this._http
      .post<T>(`${API_PATH_PREFIX}${pathSuffix}`, body, {
        withCredentials: true,
        ...options,
      })
      .pipe(
        catchError((error) => {
          // Handle OK as FORBIDDEN because CloudFront interprets it as a 404 and returns the index.html for the app. The fact that it's
          // not valid JSON means that it throws an error and falls into here for processing
          if (error.status === StatusCodes.OK) {
            return throwError(() => ({
              ...error,
              status: StatusCodes.FORBIDDEN,
            }));
          }

          return throwError(() => error);
        })
      );
  }
}
